"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var Item_1 = tslib_1.__importDefault(require("./Item"));
var context_1 = require("./context");
var Keep_1 = tslib_1.__importDefault(require("../Dropdown/Keep"));
var theme_1 = require("../../utils/theme");
var helper_1 = require("../../utils/helper");
var focus_1 = require("../../utils/focus");
var DEFAULT_METRICS = {
    verticalPlacement: 'bottom',
    horizontalPlacement: 'right',
    location: { left: '0px', top: '0px' },
    forcedHeight: 0,
};
var SUBMENU_OFFSET = -2;
var SubMenu = (function (_super) {
    tslib_1.__extends(SubMenu, _super);
    function SubMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemRef = React.createRef();
        _this.popupWrapperRef = React.createRef();
        _this.popupContentRef = React.createRef();
        _this.state = {
            visible: false,
            metrics: tslib_1.__assign({}, DEFAULT_METRICS)
        };
        _this.handleMouseEnter = function () {
            clearTimeout(_this.hideTimeout);
            if (_this.props.disabled || _this.isVisible()) {
                return;
            }
            clearTimeout(_this.showTimeout);
            _this.showTimeout = setTimeout(function () {
                _this.setState({
                    metrics: tslib_1.__assign(tslib_1.__assign({}, _this.state.metrics), { forcedHeight: 0 })
                }, function () {
                    _this.updatePopoutMetrics();
                    _this.setStateVisible(true);
                });
            }, _this.props.hoverDelay);
        };
        _this.handleMouseLeave = function (e) {
            if (_this.props.disabled || !e.relatedTarget) {
                return;
            }
            clearTimeout(_this.showTimeout);
            _this.hideTimeout = setTimeout(function () { return _this.setStateVisible(false); }, _this.props.hoverDelay);
        };
        _this.handleLeavePage = function () {
            if (_this.props.disabled || document.visibilityState !== 'hidden') {
                return;
            }
            _this.setStateVisible(false);
        };
        _this.handleSubmenuClick = function (e) {
            var onClick = _this.props.onClick;
            if (onClick) {
                var shouldKeep = onClick(e) === false;
                if (!shouldKeep) {
                    var keepEvent = e.nativeEvent;
                    keepEvent._dui_bypass_dropdown_keep = true;
                }
                return true;
            }
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            return false;
        };
        _this.handleSubMenuItemKeyDown = function (e) {
            if (_this.props.disabled) {
                return false;
            }
            if ([' ', 'Enter', 'ArrowRight'].includes(e.key)) {
                _this.handleMouseEnter();
                e.preventDefault();
                setTimeout(function () {
                    var container = _this.popupContentRef.current;
                    container && focus_1.traverseFocusIn(container, null, false);
                }, 50);
            }
            return false;
        };
        _this.handleContentKeyDown = function (e) {
            var _a;
            if (_this.props.disabled) {
                return;
            }
            var container = _this.popupContentRef.current;
            e.stopPropagation();
            if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                e.nativeEvent.stopImmediatePropagation();
                focus_1.traverseFocusIn(container, e, e.key === 'ArrowUp');
            }
            if (e.key === 'ArrowLeft') {
                _this.setStateVisible(false);
                (_a = _this.itemDom) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, id = _c.id, title = _c.title, disabled = _c.disabled, popupStyle = _c.popupStyle, popupClassName = _c.popupClassName, forcedZIndex = _c.zIndex, icon = _c.icon, selectable = _c.selectable, propType = _c.type, description = _c.description, selected = _c.selected, testId = _c.testId, popupTestId = _c.popupTestId, onClick = _c.onClick, containerDom = _c.containerDom;
            var _d = _this.context, contextZIndex = _d.zIndex, parentType = _d.type;
            var _e = _this.state.metrics, location = _e.location, verticalPlacement = _e.verticalPlacement, forcedHeight = _e.forcedHeight, horizontalPlacement = _e.horizontalPlacement;
            var zIndex = forcedZIndex || contextZIndex;
            var visible = _this.isVisible();
            var cls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-with-desc"] = description,
                _a[prefixCls + "-clickable"] = onClick,
                _a[prefixCls + "-visible"] = visible,
                _a));
            var popupWrapperCls = classNames(prefixCls + "-wrapper", prefixCls + "-wrapper-" + (visible ? 'visible' : "hidden-" + verticalPlacement));
            var type = propType || parentType;
            var contentCls = classNames(prefixCls + "-content", popupClassName, prefixCls + "-content-" + type, (_b = {},
                _b[prefixCls + "-content-non-selectable"] = !selectable,
                _b));
            return (h(context_1.SubMenuContext.Provider, { value: context_1.getSubMenuContext({
                    zIndex: zIndex + 1,
                    visible: visible,
                    type: type,
                    horizontalPlacement: horizontalPlacement,
                    viewportMargin: _this.context.viewportMargin
                }) },
                h("div", { onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave },
                    h(Keep_1.default, null,
                        h(Item_1.default, { id: id, className: cls, style: style, ref: _this.itemRef, disabled: disabled, onClick: _this.handleSubmenuClick, onKeyDown: _this.handleSubMenuItemKeyDown, icon: icon, description: description, selected: selected, "data-testid": testId }, title || id)),
                    react_dom_1.default.createPortal(h("div", { className: popupWrapperCls, ref: _this.popupWrapperRef, style: tslib_1.__assign(tslib_1.__assign({}, location), { zIndex: zIndex }) },
                        h("ul", { className: contentCls, style: tslib_1.__assign({ height: forcedHeight ? forcedHeight + "px" : undefined }, popupStyle), ref: _this.popupContentRef, role: "menu", "aria-haspopup": true, "aria-expanded": visible, onKeyDown: _this.handleContentKeyDown, "data-testid": popupTestId }, children)), containerDom || document.body))));
        };
        return _this;
    }
    SubMenu.getDerivedStateFromProps = function (props, state) {
        if (props.disabled) {
            return { visible: false };
        }
        return null;
    };
    Object.defineProperty(SubMenu.prototype, "itemDom", {
        get: function () {
            var _a;
            return (_a = this.itemRef.current) === null || _a === void 0 ? void 0 : _a.domRef.current;
        },
        enumerable: false,
        configurable: true
    });
    SubMenu.prototype.componentDidMount = function () {
        document.addEventListener('visibilitychange', this.handleLeavePage);
    };
    SubMenu.prototype.componentWillUnmount = function () {
        document.removeEventListener('visibilitychange', this.handleLeavePage);
        clearTimeout(this.hideTimeout);
        clearTimeout(this.showTimeout);
    };
    SubMenu.prototype.updatePopoutMetrics = function () {
        var itemDom = this.itemDom;
        if (!itemDom) {
            return;
        }
        var popupDom = this.popupWrapperRef.current;
        if (!popupDom) {
            return;
        }
        var maxRight = window.innerWidth, maxBottom = window.innerHeight;
        var _a = itemDom.getBoundingClientRect(), parentRight = _a.right, parentLeft = _a.left, parentTop = _a.top, parentBottom = _a.bottom;
        var _b = popupDom.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = this.context, parentMenuPlacement = _c.horizontalPlacement, viewportMargin = _c.viewportMargin;
        var availableDirections = [];
        if (parentRight + width < maxRight) {
            availableDirections.push('right');
        }
        if (parentLeft - width > 0) {
            availableDirections.push('left');
        }
        var horizontalPlacement = availableDirections.includes(parentMenuPlacement) ? parentMenuPlacement : (availableDirections[0] || 'right');
        var gap = viewportMargin;
        var remainingBottom = maxBottom - parentTop - gap;
        var remainingTop = parentBottom - gap;
        var verticalPlacement = 'bottom';
        var forcedHeight = 0;
        if (height >= remainingBottom) {
            if (height >= remainingTop) {
                if (remainingBottom >= remainingTop) {
                    verticalPlacement = 'bottom';
                    forcedHeight = remainingBottom;
                }
                else {
                    verticalPlacement = 'top';
                    forcedHeight = remainingTop;
                }
            }
            else {
                verticalPlacement = 'top';
            }
        }
        else {
            verticalPlacement = 'bottom';
        }
        var resultLeft = window.pageXOffset + (horizontalPlacement === 'right' ?
            (parentRight + SUBMENU_OFFSET)
            : (parentLeft - width - SUBMENU_OFFSET));
        var resultTop = window.pageYOffset + (verticalPlacement === 'bottom' ?
            parentTop
            : (parentBottom - (forcedHeight || height)));
        var result = {
            verticalPlacement: verticalPlacement,
            horizontalPlacement: horizontalPlacement,
            location: { left: resultLeft + "px", top: resultTop + "px" },
            forcedHeight: forcedHeight,
        };
        this.setState({ metrics: result });
    };
    SubMenu.prototype.isVisible = function () {
        var selfVisible = this.state.visible;
        var parentVisible = this.context.visible;
        var disabled = this.props.disabled;
        return parentVisible && selfVisible && !disabled;
    };
    SubMenu.prototype.setStateVisible = function (visible) {
        var _this = this;
        this.setState({ visible: visible }, function () {
            _this.props.onVisibleChange(visible);
        });
    };
    SubMenu.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    SubMenu.contextType = context_1.SubMenuContext;
    return SubMenu;
}(React.Component));
exports.default = SubMenu;
SubMenu.defaultProps = {
    prefixCls: 'dui-menu-submenu',
    id: '',
    disabled: false,
    onVisibleChange: helper_1.emptyFn,
    selectable: true,
    hoverDelay: 100,
};
